import ChevronRightIcon from '@mui/icons-material/ChevronRight';

/** Band disclosure chevron: points right when closed, down when open. */
export const Chevron = ({ open }: { open: boolean }) => (
  <ChevronRightIcon
    fontSize="small"
    aria-hidden
    sx={{
      color: 'text.secondary',
      transition: 'transform 150ms ease',
      transform: open ? 'rotate(90deg)' : 'rotate(0deg)',
      flexShrink: 0,
    }}
  />
);
